module.exports = __webpack_public_path__ + "media/promo/panasonic/images/recipes/rec-4-min-e217f574723065ce29fdd667bd0f7345.jpg";